import React, { useState } from 'react';
import { Form, Input, Button, Typography, Alert } from 'antd';
import { Link } from 'react-router-dom';
import { MailOutlined, ArrowLeftOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const ForgotPassword = () => {
    const [submitted, setSubmitted] = useState(false);
    const [email, setEmail] = useState('');

    const handleSubmit = (values) => {
        setEmail(values.email);
        setSubmitted(true);
    };

    return (
        <div style={{
            minHeight: '100vh',
            overflowY: 'auto',
            background: '#f5f5f5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '40px 16px',
        }}>
            <div style={{
                width: '100%',
                maxWidth: 420,
                background: '#fff',
                borderRadius: 12,
                padding: '40px 36px',
                boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
            }}>
                <img
                    src={require('../../assets/logo_color.png')}
                    alt="Heliosfera Energias"
                    style={{ width: '55%', display: 'block', margin: '0 auto 28px' }}
                />

                <Title level={3} style={{ textAlign: 'center', marginBottom: 6 }}>
                    Esqueceu a senha?
                </Title>
                <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginBottom: 28 }}>
                    Digite seu e-mail e entraremos em contato
                </Text>

                {!submitted ? (
                    <Form layout="vertical" onFinish={handleSubmit}>
                        <Form.Item
                            name="email"
                            rules={[
                                { required: true, message: 'Informe seu e-mail' },
                                { type: 'email', message: 'E-mail inválido' },
                            ]}
                        >
                            <Input
                                prefix={<MailOutlined style={{ color: '#bbb' }} />}
                                placeholder="seu@email.com"
                                size="large"
                            />
                        </Form.Item>

                        <Form.Item style={{ marginBottom: 12 }}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                block
                                size="large"
                                style={{ background: '#FB8500', borderColor: '#FB8500' }}
                            >
                                Enviar
                            </Button>
                        </Form.Item>

                        <div style={{ textAlign: 'center' }}>
                            <Link to="/login">
                                <ArrowLeftOutlined style={{ marginRight: 6 }} />
                                Voltar para o login
                            </Link>
                        </div>
                    </Form>
                ) : (
                    <>
                        <Alert
                            type="info"
                            showIcon
                            message="Solicitação recebida"
                            description={
                                <>
                                    Sua solicitação para o e-mail <strong>{email}</strong> foi registrada.
                                    Um administrador irá redefinir sua senha e entrar em contato em breve.
                                </>
                            }
                            style={{ marginBottom: 24 }}
                        />
                        <div style={{ textAlign: 'center' }}>
                            <Link to="/login">
                                <ArrowLeftOutlined style={{ marginRight: 6 }} />
                                Voltar para o login
                            </Link>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ForgotPassword;
